import { useCurrent } from '@/hooks/useCurrent';

export const useFeatureFlags = () => {
  const current = useCurrent();

  const ads = !!current.tenant?.featureFlags?.ads;
  const reporting = !!current.tenant?.featureFlags?.reporting;
  const topSessionBanner = !!current.tenant?.featureFlags?.topSessionBanner;
  const disableFtue = !!current.tenant?.featureFlags?.disableFtue;
  const historicalDataImport =
    !!current.tenant?.featureFlags?.historicalDataImport;
  const conferences = !!current.tenant?.featureFlags?.conferences;
  const mobileGrowth = !!current.tenant?.featureFlags?.mobileGrowth;
  const cms = !!current.tenant?.featureFlags?.cms;
  const setReferrerPolicy = !!current.tenant?.featureFlags?.setReferrerPolicy;
  const invoicing = !!current.tenant?.featureFlags?.invoicing;
  const isMembershipV2Enabled =
    !!current.tenant?.featureFlags?.isMembershipV2Enabled;
  const isMembershipInstallmentsEnabled =
    !!current.tenant?.featureFlags?.isMembershipInstallmentsEnabled;
  const showIntegrationLogs =
    !!current.tenant?.featureFlags?.showIntegrationLogs;
  const showPermissionGroups =
    !!current.tenant?.featureFlags?.showPermissionGroups;
  const webflow = !!current.tenant?.featureFlags?.webflow;
  const sharedCommunityAccess =
    !!current.tenant?.featureFlags?.sharedCommunityAccess;
  const mentorshipEnabled = !!current.tenant?.featureFlags?.mentorshipEnabled;
  const hideDateAndTimeForCourses =
    !!current.tenant?.featureFlags?.hideDateAndTimeForCourses;
  const websiteBuilderEmbed =
    !!current.tenant?.featureFlags?.websiteBuilderEmbed;
  const attributeLibrary =
    !!current.tenant?.featureFlags?.attributeLibrary;
  const autoArchive = !!current.tenant?.featureFlags?.autoArchive;

  return {
    ads,
    reporting,
    topSessionBanner,
    disableFtue,
    conferences,
    historicalDataImport,
    mobileGrowth,
    cms,
    setReferrerPolicy,
    invoicing,
    isMembershipV2Enabled,
    isMembershipInstallmentsEnabled,
    showIntegrationLogs,
    showPermissionGroups,
    webflow,
    sharedCommunityAccess,
    mentorshipEnabled,
    hideDateAndTimeForCourses,
    websiteBuilderEmbed,
    attributeLibrary,
    autoArchive,
  };
};
